import React from 'react'

const Banner = () => {
    return (
        <section className="main">
            <div className="container">
                <div className="row">
                    <h2>
                        <div className="line">
                            <span>Bespoke web development</span>
                        </div>
                        <div className="line">
                            <span>for a competitive world.</span>
                        </div>
                    </h2>
                </div>
            </div>
        </section>
    )
}

export default Banner
